/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/routes/__root';
import { Route as AppRouteImport } from './app/routes/_app';
import { Route as AuthRouteImport } from './app/routes/_auth';
import { Route as ChangePasswordRouteImport } from './app/routes/change-password';
import { Route as HelpRouteImport } from './app/routes/help';
import { Route as ThemeRouteRouteImport } from './app/routes/theme/route';
import { Route as AppIndexRouteImport } from './app/routes/_app/index';
import { Route as AppAutomationsRouteRouteImport } from './app/routes/_app/automations/route';
import { Route as AppCampaignsRouteRouteImport } from './app/routes/_app/campaigns/route';
import { Route as AppCaptureRouteRouteImport } from './app/routes/_app/capture/route';
import { Route as AppConversationsRouteImport } from './app/routes/_app/conversations';
import { Route as AppReportsRouteImport } from './app/routes/_app/reports';
import { Route as AppSupervisionRouteImport } from './app/routes/_app/supervision';
import { Route as AppTasksRouteImport } from './app/routes/_app/tasks';
import { Route as AuthForgotPasswordRouteImport } from './app/routes/_auth/forgot-password';
import { Route as AuthLoginRouteImport } from './app/routes/_auth/login';
import { Route as AuthRegisterRouteImport } from './app/routes/_auth/register';
import { Route as AuthResetPasswordRouteImport } from './app/routes/_auth/reset-password';
import { Route as HelpIndexRouteImport } from './app/routes/help/index';
import { Route as HelpSplatRouteImport } from './app/routes/help/$';
import { Route as InscricaoTokenRouteImport } from './app/routes/inscricao.$token';
import { Route as ThemeIndexRouteImport } from './app/routes/theme/index';
import { Route as ThemeKanbanRouteImport } from './app/routes/theme/kanban';
import { Route as ThemeListRouteImport } from './app/routes/theme/list';
import { Route as AppAutomationsIndexRouteImport } from './app/routes/_app/automations/index';
import { Route as AppAutomationsAutomationIdRouteImport } from './app/routes/_app/automations/$automationId';
import { Route as AppAutomationsNewRouteImport } from './app/routes/_app/automations/new';
import { Route as AppCampaignsIndexRouteImport } from './app/routes/_app/campaigns/index';
import { Route as AppCampaignsTemplatesRouteImport } from './app/routes/_app/campaigns/templates';
import { Route as AppCaptureIndexRouteImport } from './app/routes/_app/capture/index';
import { Route as AppCaptureSourcesRouteImport } from './app/routes/_app/capture/sources';
import { Route as AppContactsIndexRouteImport } from './app/routes/_app/contacts/index';
import { Route as AppCustomersIndexRouteImport } from './app/routes/_app/customers/index';
import { Route as AppCustomersCustomerIdRouteImport } from './app/routes/_app/customers/$customerId';
import { Route as AppDealsIndexRouteImport } from './app/routes/_app/deals/index';
import { Route as AppDealsDealIdRouteImport } from './app/routes/_app/deals/$dealId';
import { Route as AppDealsLeadsRouteImport } from './app/routes/_app/deals/leads';
import { Route as AppImportsIndexRouteImport } from './app/routes/_app/imports/index';
import { Route as AppImportsImportIdRouteImport } from './app/routes/_app/imports/$importId';
import { Route as AppLeadsIndexRouteImport } from './app/routes/_app/leads/index';
import { Route as AppLeadsLeadIdRouteImport } from './app/routes/_app/leads/$leadId';
import { Route as AppProposalsIndexRouteImport } from './app/routes/_app/proposals/index';
import { Route as AppProposalsProposalIdRouteImport } from './app/routes/_app/proposals/$proposalId';
import { Route as AppTicketsTicketIdRouteImport } from './app/routes/_app/tickets/$ticketId';
import { Route as ChannelsInstagramCallbackRouteImport } from './app/routes/channels/instagram/callback';
import { Route as AppCampaignsAudiencesIndexRouteImport } from './app/routes/_app/campaigns/audiences/index';
import { Route as AppCampaignsBroadcastsIndexRouteImport } from './app/routes/_app/campaigns/broadcasts/index';
import { Route as AppCampaignsBroadcastsBroadcastIdRouteImport } from './app/routes/_app/campaigns/broadcasts/$broadcastId';
import { Route as AppCampaignsEventsIndexRouteImport } from './app/routes/_app/campaigns/events/index';
import { Route as AppCampaignsEventsEventIdRouteImport } from './app/routes/_app/campaigns/events/$eventId';
import { Route as AppCampaignsJourneysIndexRouteImport } from './app/routes/_app/campaigns/journeys/index';
import { Route as AppCampaignsJourneysJourneyIdRouteImport } from './app/routes/_app/campaigns/journeys/$journeyId';
import { Route as AppCaptureFormsIndexRouteImport } from './app/routes/_app/capture/forms/index';
import { Route as AppCaptureFormsFormIdRouteRouteImport } from './app/routes/_app/capture/forms/$formId/route';
import { Route as AppCaptureReferralsIndexRouteImport } from './app/routes/_app/capture/referrals/index';
import { Route as AppCaptureFormsFormIdIndexRouteImport } from './app/routes/_app/capture/forms/$formId/index';
import { Route as AppCaptureFormsFormIdOptionsRouteImport } from './app/routes/_app/capture/forms/$formId/options';
import { Route as AppCaptureFormsFormIdResponsesRouteImport } from './app/routes/_app/capture/forms/$formId/responses';
import { Route as AppCaptureFormsFormIdShareRouteImport } from './app/routes/_app/capture/forms/$formId/share';

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any);
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any);
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any);
const ThemeRouteRoute = ThemeRouteRouteImport.update({
  id: '/theme',
  path: '/theme',
  getParentRoute: () => rootRouteImport,
} as any);
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any);
const AppAutomationsRouteRoute = AppAutomationsRouteRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => AppRoute,
} as any);
const AppCampaignsRouteRoute = AppCampaignsRouteRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => AppRoute,
} as any);
const AppCaptureRouteRoute = AppCaptureRouteRouteImport.update({
  id: '/capture',
  path: '/capture',
  getParentRoute: () => AppRoute,
} as any);
const AppConversationsRoute = AppConversationsRouteImport.update({
  id: '/conversations',
  path: '/conversations',
  getParentRoute: () => AppRoute,
} as any);
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any);
const AppSupervisionRoute = AppSupervisionRouteImport.update({
  id: '/supervision',
  path: '/supervision',
  getParentRoute: () => AppRoute,
} as any);
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any);
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any);
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any);
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any);
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any);
const HelpIndexRoute = HelpIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HelpRoute,
} as any);
const HelpSplatRoute = HelpSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => HelpRoute,
} as any);
const InscricaoTokenRoute = InscricaoTokenRouteImport.update({
  id: '/inscricao/$token',
  path: '/inscricao/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const ThemeIndexRoute = ThemeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ThemeRouteRoute,
} as any);
const ThemeKanbanRoute = ThemeKanbanRouteImport.update({
  id: '/kanban',
  path: '/kanban',
  getParentRoute: () => ThemeRouteRoute,
} as any);
const ThemeListRoute = ThemeListRouteImport.update({
  id: '/list',
  path: '/list',
  getParentRoute: () => ThemeRouteRoute,
} as any);
const AppAutomationsIndexRoute = AppAutomationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAutomationsRouteRoute,
} as any);
const AppAutomationsAutomationIdRoute =
  AppAutomationsAutomationIdRouteImport.update({
    id: '/$automationId',
    path: '/$automationId',
    getParentRoute: () => AppAutomationsRouteRoute,
  } as any);
const AppAutomationsNewRoute = AppAutomationsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAutomationsRouteRoute,
} as any);
const AppCampaignsIndexRoute = AppCampaignsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCampaignsRouteRoute,
} as any);
const AppCampaignsTemplatesRoute = AppCampaignsTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppCampaignsRouteRoute,
} as any);
const AppCaptureIndexRoute = AppCaptureIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCaptureRouteRoute,
} as any);
const AppCaptureSourcesRoute = AppCaptureSourcesRouteImport.update({
  id: '/sources',
  path: '/sources',
  getParentRoute: () => AppCaptureRouteRoute,
} as any);
const AppContactsIndexRoute = AppContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => AppRoute,
} as any);
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any);
const AppCustomersCustomerIdRoute = AppCustomersCustomerIdRouteImport.update({
  id: '/customers/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => AppRoute,
} as any);
const AppDealsIndexRoute = AppDealsIndexRouteImport.update({
  id: '/deals/',
  path: '/deals/',
  getParentRoute: () => AppRoute,
} as any);
const AppDealsDealIdRoute = AppDealsDealIdRouteImport.update({
  id: '/deals/$dealId',
  path: '/deals/$dealId',
  getParentRoute: () => AppRoute,
} as any);
const AppDealsLeadsRoute = AppDealsLeadsRouteImport.update({
  id: '/deals/leads',
  path: '/deals/leads',
  getParentRoute: () => AppRoute,
} as any);
const AppImportsIndexRoute = AppImportsIndexRouteImport.update({
  id: '/imports/',
  path: '/imports/',
  getParentRoute: () => AppRoute,
} as any);
const AppImportsImportIdRoute = AppImportsImportIdRouteImport.update({
  id: '/imports/$importId',
  path: '/imports/$importId',
  getParentRoute: () => AppRoute,
} as any);
const AppLeadsIndexRoute = AppLeadsIndexRouteImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => AppRoute,
} as any);
const AppLeadsLeadIdRoute = AppLeadsLeadIdRouteImport.update({
  id: '/leads/$leadId',
  path: '/leads/$leadId',
  getParentRoute: () => AppRoute,
} as any);
const AppProposalsIndexRoute = AppProposalsIndexRouteImport.update({
  id: '/proposals/',
  path: '/proposals/',
  getParentRoute: () => AppRoute,
} as any);
const AppProposalsProposalIdRoute = AppProposalsProposalIdRouteImport.update({
  id: '/proposals/$proposalId',
  path: '/proposals/$proposalId',
  getParentRoute: () => AppRoute,
} as any);
const AppTicketsTicketIdRoute = AppTicketsTicketIdRouteImport.update({
  id: '/tickets/$ticketId',
  path: '/tickets/$ticketId',
  getParentRoute: () => AppRoute,
} as any);
const ChannelsInstagramCallbackRoute =
  ChannelsInstagramCallbackRouteImport.update({
    id: '/channels/instagram/callback',
    path: '/channels/instagram/callback',
    getParentRoute: () => rootRouteImport,
  } as any);
const AppCampaignsAudiencesIndexRoute =
  AppCampaignsAudiencesIndexRouteImport.update({
    id: '/audiences/',
    path: '/audiences/',
    getParentRoute: () => AppCampaignsRouteRoute,
  } as any);
const AppCampaignsBroadcastsIndexRoute =
  AppCampaignsBroadcastsIndexRouteImport.update({
    id: '/broadcasts/',
    path: '/broadcasts/',
    getParentRoute: () => AppCampaignsRouteRoute,
  } as any);
const AppCampaignsBroadcastsBroadcastIdRoute =
  AppCampaignsBroadcastsBroadcastIdRouteImport.update({
    id: '/broadcasts/$broadcastId',
    path: '/broadcasts/$broadcastId',
    getParentRoute: () => AppCampaignsRouteRoute,
  } as any);
const AppCampaignsEventsIndexRoute = AppCampaignsEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => AppCampaignsRouteRoute,
} as any);
const AppCampaignsEventsEventIdRoute =
  AppCampaignsEventsEventIdRouteImport.update({
    id: '/events/$eventId',
    path: '/events/$eventId',
    getParentRoute: () => AppCampaignsRouteRoute,
  } as any);
const AppCampaignsJourneysIndexRoute =
  AppCampaignsJourneysIndexRouteImport.update({
    id: '/journeys/',
    path: '/journeys/',
    getParentRoute: () => AppCampaignsRouteRoute,
  } as any);
const AppCampaignsJourneysJourneyIdRoute =
  AppCampaignsJourneysJourneyIdRouteImport.update({
    id: '/journeys/$journeyId',
    path: '/journeys/$journeyId',
    getParentRoute: () => AppCampaignsRouteRoute,
  } as any);
const AppCaptureFormsIndexRoute = AppCaptureFormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => AppCaptureRouteRoute,
} as any);
const AppCaptureFormsFormIdRouteRoute =
  AppCaptureFormsFormIdRouteRouteImport.update({
    id: '/forms/$formId',
    path: '/forms/$formId',
    getParentRoute: () => AppCaptureRouteRoute,
  } as any);
const AppCaptureReferralsIndexRoute =
  AppCaptureReferralsIndexRouteImport.update({
    id: '/referrals/',
    path: '/referrals/',
    getParentRoute: () => AppCaptureRouteRoute,
  } as any);
const AppCaptureFormsFormIdIndexRoute =
  AppCaptureFormsFormIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCaptureFormsFormIdRouteRoute,
  } as any);
const AppCaptureFormsFormIdOptionsRoute =
  AppCaptureFormsFormIdOptionsRouteImport.update({
    id: '/options',
    path: '/options',
    getParentRoute: () => AppCaptureFormsFormIdRouteRoute,
  } as any);
const AppCaptureFormsFormIdResponsesRoute =
  AppCaptureFormsFormIdResponsesRouteImport.update({
    id: '/responses',
    path: '/responses',
    getParentRoute: () => AppCaptureFormsFormIdRouteRoute,
  } as any);
const AppCaptureFormsFormIdShareRoute =
  AppCaptureFormsFormIdShareRouteImport.update({
    id: '/share',
    path: '/share',
    getParentRoute: () => AppCaptureFormsFormIdRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/theme': typeof ThemeRouteRouteWithChildren;
  '/': typeof AppIndexRoute;
  '/change-password': typeof ChangePasswordRoute;
  '/help': typeof HelpRouteWithChildren;
  '/automations': typeof AppAutomationsRouteRouteWithChildren;
  '/campaigns': typeof AppCampaignsRouteRouteWithChildren;
  '/capture': typeof AppCaptureRouteRouteWithChildren;
  '/conversations': typeof AppConversationsRoute;
  '/reports': typeof AppReportsRoute;
  '/supervision': typeof AppSupervisionRoute;
  '/tasks': typeof AppTasksRoute;
  '/forgot-password': typeof AuthForgotPasswordRoute;
  '/login': typeof AuthLoginRoute;
  '/register': typeof AuthRegisterRoute;
  '/reset-password': typeof AuthResetPasswordRoute;
  '/help/$': typeof HelpSplatRoute;
  '/inscricao/$token': typeof InscricaoTokenRoute;
  '/theme/kanban': typeof ThemeKanbanRoute;
  '/theme/list': typeof ThemeListRoute;
  '/help/': typeof HelpIndexRoute;
  '/theme/': typeof ThemeIndexRoute;
  '/automations/$automationId': typeof AppAutomationsAutomationIdRoute;
  '/automations/new': typeof AppAutomationsNewRoute;
  '/campaigns/templates': typeof AppCampaignsTemplatesRoute;
  '/capture/sources': typeof AppCaptureSourcesRoute;
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute;
  '/deals/$dealId': typeof AppDealsDealIdRoute;
  '/deals/leads': typeof AppDealsLeadsRoute;
  '/imports/$importId': typeof AppImportsImportIdRoute;
  '/leads/$leadId': typeof AppLeadsLeadIdRoute;
  '/proposals/$proposalId': typeof AppProposalsProposalIdRoute;
  '/tickets/$ticketId': typeof AppTicketsTicketIdRoute;
  '/channels/instagram/callback': typeof ChannelsInstagramCallbackRoute;
  '/automations/': typeof AppAutomationsIndexRoute;
  '/campaigns/': typeof AppCampaignsIndexRoute;
  '/capture/': typeof AppCaptureIndexRoute;
  '/contacts/': typeof AppContactsIndexRoute;
  '/customers/': typeof AppCustomersIndexRoute;
  '/deals/': typeof AppDealsIndexRoute;
  '/imports/': typeof AppImportsIndexRoute;
  '/leads/': typeof AppLeadsIndexRoute;
  '/proposals/': typeof AppProposalsIndexRoute;
  '/capture/forms/$formId': typeof AppCaptureFormsFormIdRouteRouteWithChildren;
  '/campaigns/broadcasts/$broadcastId': typeof AppCampaignsBroadcastsBroadcastIdRoute;
  '/campaigns/events/$eventId': typeof AppCampaignsEventsEventIdRoute;
  '/campaigns/journeys/$journeyId': typeof AppCampaignsJourneysJourneyIdRoute;
  '/campaigns/audiences/': typeof AppCampaignsAudiencesIndexRoute;
  '/campaigns/broadcasts/': typeof AppCampaignsBroadcastsIndexRoute;
  '/campaigns/events/': typeof AppCampaignsEventsIndexRoute;
  '/campaigns/journeys/': typeof AppCampaignsJourneysIndexRoute;
  '/capture/forms/': typeof AppCaptureFormsIndexRoute;
  '/capture/referrals/': typeof AppCaptureReferralsIndexRoute;
  '/capture/forms/$formId/options': typeof AppCaptureFormsFormIdOptionsRoute;
  '/capture/forms/$formId/responses': typeof AppCaptureFormsFormIdResponsesRoute;
  '/capture/forms/$formId/share': typeof AppCaptureFormsFormIdShareRoute;
  '/capture/forms/$formId/': typeof AppCaptureFormsFormIdIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute;
  '/change-password': typeof ChangePasswordRoute;
  '/conversations': typeof AppConversationsRoute;
  '/reports': typeof AppReportsRoute;
  '/supervision': typeof AppSupervisionRoute;
  '/tasks': typeof AppTasksRoute;
  '/forgot-password': typeof AuthForgotPasswordRoute;
  '/login': typeof AuthLoginRoute;
  '/register': typeof AuthRegisterRoute;
  '/reset-password': typeof AuthResetPasswordRoute;
  '/help/$': typeof HelpSplatRoute;
  '/inscricao/$token': typeof InscricaoTokenRoute;
  '/theme/kanban': typeof ThemeKanbanRoute;
  '/theme/list': typeof ThemeListRoute;
  '/help': typeof HelpIndexRoute;
  '/theme': typeof ThemeIndexRoute;
  '/automations/$automationId': typeof AppAutomationsAutomationIdRoute;
  '/automations/new': typeof AppAutomationsNewRoute;
  '/campaigns/templates': typeof AppCampaignsTemplatesRoute;
  '/capture/sources': typeof AppCaptureSourcesRoute;
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute;
  '/deals/$dealId': typeof AppDealsDealIdRoute;
  '/deals/leads': typeof AppDealsLeadsRoute;
  '/imports/$importId': typeof AppImportsImportIdRoute;
  '/leads/$leadId': typeof AppLeadsLeadIdRoute;
  '/proposals/$proposalId': typeof AppProposalsProposalIdRoute;
  '/tickets/$ticketId': typeof AppTicketsTicketIdRoute;
  '/channels/instagram/callback': typeof ChannelsInstagramCallbackRoute;
  '/automations': typeof AppAutomationsIndexRoute;
  '/campaigns': typeof AppCampaignsIndexRoute;
  '/capture': typeof AppCaptureIndexRoute;
  '/contacts': typeof AppContactsIndexRoute;
  '/customers': typeof AppCustomersIndexRoute;
  '/deals': typeof AppDealsIndexRoute;
  '/imports': typeof AppImportsIndexRoute;
  '/leads': typeof AppLeadsIndexRoute;
  '/proposals': typeof AppProposalsIndexRoute;
  '/campaigns/broadcasts/$broadcastId': typeof AppCampaignsBroadcastsBroadcastIdRoute;
  '/campaigns/events/$eventId': typeof AppCampaignsEventsEventIdRoute;
  '/campaigns/journeys/$journeyId': typeof AppCampaignsJourneysJourneyIdRoute;
  '/campaigns/audiences': typeof AppCampaignsAudiencesIndexRoute;
  '/campaigns/broadcasts': typeof AppCampaignsBroadcastsIndexRoute;
  '/campaigns/events': typeof AppCampaignsEventsIndexRoute;
  '/campaigns/journeys': typeof AppCampaignsJourneysIndexRoute;
  '/capture/forms': typeof AppCaptureFormsIndexRoute;
  '/capture/referrals': typeof AppCaptureReferralsIndexRoute;
  '/capture/forms/$formId/options': typeof AppCaptureFormsFormIdOptionsRoute;
  '/capture/forms/$formId/responses': typeof AppCaptureFormsFormIdResponsesRoute;
  '/capture/forms/$formId/share': typeof AppCaptureFormsFormIdShareRoute;
  '/capture/forms/$formId': typeof AppCaptureFormsFormIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/theme': typeof ThemeRouteRouteWithChildren;
  '/_app': typeof AppRouteWithChildren;
  '/_auth': typeof AuthRouteWithChildren;
  '/change-password': typeof ChangePasswordRoute;
  '/help': typeof HelpRouteWithChildren;
  '/_app/automations': typeof AppAutomationsRouteRouteWithChildren;
  '/_app/campaigns': typeof AppCampaignsRouteRouteWithChildren;
  '/_app/capture': typeof AppCaptureRouteRouteWithChildren;
  '/_app/conversations': typeof AppConversationsRoute;
  '/_app/reports': typeof AppReportsRoute;
  '/_app/supervision': typeof AppSupervisionRoute;
  '/_app/tasks': typeof AppTasksRoute;
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute;
  '/_auth/login': typeof AuthLoginRoute;
  '/_auth/register': typeof AuthRegisterRoute;
  '/_auth/reset-password': typeof AuthResetPasswordRoute;
  '/help/$': typeof HelpSplatRoute;
  '/inscricao/$token': typeof InscricaoTokenRoute;
  '/theme/kanban': typeof ThemeKanbanRoute;
  '/theme/list': typeof ThemeListRoute;
  '/_app/': typeof AppIndexRoute;
  '/help/': typeof HelpIndexRoute;
  '/theme/': typeof ThemeIndexRoute;
  '/_app/automations/$automationId': typeof AppAutomationsAutomationIdRoute;
  '/_app/automations/new': typeof AppAutomationsNewRoute;
  '/_app/campaigns/templates': typeof AppCampaignsTemplatesRoute;
  '/_app/capture/sources': typeof AppCaptureSourcesRoute;
  '/_app/customers/$customerId': typeof AppCustomersCustomerIdRoute;
  '/_app/deals/$dealId': typeof AppDealsDealIdRoute;
  '/_app/deals/leads': typeof AppDealsLeadsRoute;
  '/_app/imports/$importId': typeof AppImportsImportIdRoute;
  '/_app/leads/$leadId': typeof AppLeadsLeadIdRoute;
  '/_app/proposals/$proposalId': typeof AppProposalsProposalIdRoute;
  '/_app/tickets/$ticketId': typeof AppTicketsTicketIdRoute;
  '/channels/instagram/callback': typeof ChannelsInstagramCallbackRoute;
  '/_app/automations/': typeof AppAutomationsIndexRoute;
  '/_app/campaigns/': typeof AppCampaignsIndexRoute;
  '/_app/capture/': typeof AppCaptureIndexRoute;
  '/_app/contacts/': typeof AppContactsIndexRoute;
  '/_app/customers/': typeof AppCustomersIndexRoute;
  '/_app/deals/': typeof AppDealsIndexRoute;
  '/_app/imports/': typeof AppImportsIndexRoute;
  '/_app/leads/': typeof AppLeadsIndexRoute;
  '/_app/proposals/': typeof AppProposalsIndexRoute;
  '/_app/capture/forms/$formId': typeof AppCaptureFormsFormIdRouteRouteWithChildren;
  '/_app/campaigns/broadcasts/$broadcastId': typeof AppCampaignsBroadcastsBroadcastIdRoute;
  '/_app/campaigns/events/$eventId': typeof AppCampaignsEventsEventIdRoute;
  '/_app/campaigns/journeys/$journeyId': typeof AppCampaignsJourneysJourneyIdRoute;
  '/_app/campaigns/audiences/': typeof AppCampaignsAudiencesIndexRoute;
  '/_app/campaigns/broadcasts/': typeof AppCampaignsBroadcastsIndexRoute;
  '/_app/campaigns/events/': typeof AppCampaignsEventsIndexRoute;
  '/_app/campaigns/journeys/': typeof AppCampaignsJourneysIndexRoute;
  '/_app/capture/forms/': typeof AppCaptureFormsIndexRoute;
  '/_app/capture/referrals/': typeof AppCaptureReferralsIndexRoute;
  '/_app/capture/forms/$formId/options': typeof AppCaptureFormsFormIdOptionsRoute;
  '/_app/capture/forms/$formId/responses': typeof AppCaptureFormsFormIdResponsesRoute;
  '/_app/capture/forms/$formId/share': typeof AppCaptureFormsFormIdShareRoute;
  '/_app/capture/forms/$formId/': typeof AppCaptureFormsFormIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/theme'
    | '/'
    | '/change-password'
    | '/help'
    | '/automations'
    | '/campaigns'
    | '/capture'
    | '/conversations'
    | '/reports'
    | '/supervision'
    | '/tasks'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/help/$'
    | '/inscricao/$token'
    | '/theme/kanban'
    | '/theme/list'
    | '/help/'
    | '/theme/'
    | '/automations/$automationId'
    | '/automations/new'
    | '/campaigns/templates'
    | '/capture/sources'
    | '/customers/$customerId'
    | '/deals/$dealId'
    | '/deals/leads'
    | '/imports/$importId'
    | '/leads/$leadId'
    | '/proposals/$proposalId'
    | '/tickets/$ticketId'
    | '/channels/instagram/callback'
    | '/automations/'
    | '/campaigns/'
    | '/capture/'
    | '/contacts/'
    | '/customers/'
    | '/deals/'
    | '/imports/'
    | '/leads/'
    | '/proposals/'
    | '/capture/forms/$formId'
    | '/campaigns/broadcasts/$broadcastId'
    | '/campaigns/events/$eventId'
    | '/campaigns/journeys/$journeyId'
    | '/campaigns/audiences/'
    | '/campaigns/broadcasts/'
    | '/campaigns/events/'
    | '/campaigns/journeys/'
    | '/capture/forms/'
    | '/capture/referrals/'
    | '/capture/forms/$formId/options'
    | '/capture/forms/$formId/responses'
    | '/capture/forms/$formId/share'
    | '/capture/forms/$formId/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/change-password'
    | '/conversations'
    | '/reports'
    | '/supervision'
    | '/tasks'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/help/$'
    | '/inscricao/$token'
    | '/theme/kanban'
    | '/theme/list'
    | '/help'
    | '/theme'
    | '/automations/$automationId'
    | '/automations/new'
    | '/campaigns/templates'
    | '/capture/sources'
    | '/customers/$customerId'
    | '/deals/$dealId'
    | '/deals/leads'
    | '/imports/$importId'
    | '/leads/$leadId'
    | '/proposals/$proposalId'
    | '/tickets/$ticketId'
    | '/channels/instagram/callback'
    | '/automations'
    | '/campaigns'
    | '/capture'
    | '/contacts'
    | '/customers'
    | '/deals'
    | '/imports'
    | '/leads'
    | '/proposals'
    | '/campaigns/broadcasts/$broadcastId'
    | '/campaigns/events/$eventId'
    | '/campaigns/journeys/$journeyId'
    | '/campaigns/audiences'
    | '/campaigns/broadcasts'
    | '/campaigns/events'
    | '/campaigns/journeys'
    | '/capture/forms'
    | '/capture/referrals'
    | '/capture/forms/$formId/options'
    | '/capture/forms/$formId/responses'
    | '/capture/forms/$formId/share'
    | '/capture/forms/$formId';
  id:
    | '__root__'
    | '/theme'
    | '/_app'
    | '/_auth'
    | '/change-password'
    | '/help'
    | '/_app/automations'
    | '/_app/campaigns'
    | '/_app/capture'
    | '/_app/conversations'
    | '/_app/reports'
    | '/_app/supervision'
    | '/_app/tasks'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/register'
    | '/_auth/reset-password'
    | '/help/$'
    | '/inscricao/$token'
    | '/theme/kanban'
    | '/theme/list'
    | '/_app/'
    | '/help/'
    | '/theme/'
    | '/_app/automations/$automationId'
    | '/_app/automations/new'
    | '/_app/campaigns/templates'
    | '/_app/capture/sources'
    | '/_app/customers/$customerId'
    | '/_app/deals/$dealId'
    | '/_app/deals/leads'
    | '/_app/imports/$importId'
    | '/_app/leads/$leadId'
    | '/_app/proposals/$proposalId'
    | '/_app/tickets/$ticketId'
    | '/channels/instagram/callback'
    | '/_app/automations/'
    | '/_app/campaigns/'
    | '/_app/capture/'
    | '/_app/contacts/'
    | '/_app/customers/'
    | '/_app/deals/'
    | '/_app/imports/'
    | '/_app/leads/'
    | '/_app/proposals/'
    | '/_app/capture/forms/$formId'
    | '/_app/campaigns/broadcasts/$broadcastId'
    | '/_app/campaigns/events/$eventId'
    | '/_app/campaigns/journeys/$journeyId'
    | '/_app/campaigns/audiences/'
    | '/_app/campaigns/broadcasts/'
    | '/_app/campaigns/events/'
    | '/_app/campaigns/journeys/'
    | '/_app/capture/forms/'
    | '/_app/capture/referrals/'
    | '/_app/capture/forms/$formId/options'
    | '/_app/capture/forms/$formId/responses'
    | '/_app/capture/forms/$formId/share'
    | '/_app/capture/forms/$formId/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  ThemeRouteRoute: typeof ThemeRouteRouteWithChildren;
  AppRoute: typeof AppRouteWithChildren;
  AuthRoute: typeof AuthRouteWithChildren;
  ChangePasswordRoute: typeof ChangePasswordRoute;
  HelpRoute: typeof HelpRouteWithChildren;
  InscricaoTokenRoute: typeof InscricaoTokenRoute;
  ChannelsInstagramCallbackRoute: typeof ChannelsInstagramCallbackRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_auth': {
      id: '/_auth';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/change-password': {
      id: '/change-password';
      path: '/change-password';
      fullPath: '/change-password';
      preLoaderRoute: typeof ChangePasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/help': {
      id: '/help';
      path: '/help';
      fullPath: '/help';
      preLoaderRoute: typeof HelpRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/theme': {
      id: '/theme';
      path: '/theme';
      fullPath: '/theme';
      preLoaderRoute: typeof ThemeRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app/': {
      id: '/_app/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AppIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/automations': {
      id: '/_app/automations';
      path: '/automations';
      fullPath: '/automations';
      preLoaderRoute: typeof AppAutomationsRouteRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/campaigns': {
      id: '/_app/campaigns';
      path: '/campaigns';
      fullPath: '/campaigns';
      preLoaderRoute: typeof AppCampaignsRouteRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/capture': {
      id: '/_app/capture';
      path: '/capture';
      fullPath: '/capture';
      preLoaderRoute: typeof AppCaptureRouteRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/conversations': {
      id: '/_app/conversations';
      path: '/conversations';
      fullPath: '/conversations';
      preLoaderRoute: typeof AppConversationsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/reports': {
      id: '/_app/reports';
      path: '/reports';
      fullPath: '/reports';
      preLoaderRoute: typeof AppReportsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/supervision': {
      id: '/_app/supervision';
      path: '/supervision';
      fullPath: '/supervision';
      preLoaderRoute: typeof AppSupervisionRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/tasks': {
      id: '/_app/tasks';
      path: '/tasks';
      fullPath: '/tasks';
      preLoaderRoute: typeof AppTasksRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof AuthForgotPasswordRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/login': {
      id: '/_auth/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof AuthLoginRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/register': {
      id: '/_auth/register';
      path: '/register';
      fullPath: '/register';
      preLoaderRoute: typeof AuthRegisterRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/reset-password': {
      id: '/_auth/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof AuthResetPasswordRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/help/': {
      id: '/help/';
      path: '/';
      fullPath: '/help/';
      preLoaderRoute: typeof HelpIndexRouteImport;
      parentRoute: typeof HelpRoute;
    };
    '/help/$': {
      id: '/help/$';
      path: '/$';
      fullPath: '/help/$';
      preLoaderRoute: typeof HelpSplatRouteImport;
      parentRoute: typeof HelpRoute;
    };
    '/inscricao/$token': {
      id: '/inscricao/$token';
      path: '/inscricao/$token';
      fullPath: '/inscricao/$token';
      preLoaderRoute: typeof InscricaoTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/theme/': {
      id: '/theme/';
      path: '/';
      fullPath: '/theme/';
      preLoaderRoute: typeof ThemeIndexRouteImport;
      parentRoute: typeof ThemeRouteRoute;
    };
    '/theme/kanban': {
      id: '/theme/kanban';
      path: '/kanban';
      fullPath: '/theme/kanban';
      preLoaderRoute: typeof ThemeKanbanRouteImport;
      parentRoute: typeof ThemeRouteRoute;
    };
    '/theme/list': {
      id: '/theme/list';
      path: '/list';
      fullPath: '/theme/list';
      preLoaderRoute: typeof ThemeListRouteImport;
      parentRoute: typeof ThemeRouteRoute;
    };
    '/_app/automations/': {
      id: '/_app/automations/';
      path: '/';
      fullPath: '/automations/';
      preLoaderRoute: typeof AppAutomationsIndexRouteImport;
      parentRoute: typeof AppAutomationsRouteRoute;
    };
    '/_app/automations/$automationId': {
      id: '/_app/automations/$automationId';
      path: '/$automationId';
      fullPath: '/automations/$automationId';
      preLoaderRoute: typeof AppAutomationsAutomationIdRouteImport;
      parentRoute: typeof AppAutomationsRouteRoute;
    };
    '/_app/automations/new': {
      id: '/_app/automations/new';
      path: '/new';
      fullPath: '/automations/new';
      preLoaderRoute: typeof AppAutomationsNewRouteImport;
      parentRoute: typeof AppAutomationsRouteRoute;
    };
    '/_app/campaigns/': {
      id: '/_app/campaigns/';
      path: '/';
      fullPath: '/campaigns/';
      preLoaderRoute: typeof AppCampaignsIndexRouteImport;
      parentRoute: typeof AppCampaignsRouteRoute;
    };
    '/_app/campaigns/templates': {
      id: '/_app/campaigns/templates';
      path: '/templates';
      fullPath: '/campaigns/templates';
      preLoaderRoute: typeof AppCampaignsTemplatesRouteImport;
      parentRoute: typeof AppCampaignsRouteRoute;
    };
    '/_app/capture/': {
      id: '/_app/capture/';
      path: '/';
      fullPath: '/capture/';
      preLoaderRoute: typeof AppCaptureIndexRouteImport;
      parentRoute: typeof AppCaptureRouteRoute;
    };
    '/_app/capture/sources': {
      id: '/_app/capture/sources';
      path: '/sources';
      fullPath: '/capture/sources';
      preLoaderRoute: typeof AppCaptureSourcesRouteImport;
      parentRoute: typeof AppCaptureRouteRoute;
    };
    '/_app/contacts/': {
      id: '/_app/contacts/';
      path: '/contacts';
      fullPath: '/contacts/';
      preLoaderRoute: typeof AppContactsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/customers/': {
      id: '/_app/customers/';
      path: '/customers';
      fullPath: '/customers/';
      preLoaderRoute: typeof AppCustomersIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/customers/$customerId': {
      id: '/_app/customers/$customerId';
      path: '/customers/$customerId';
      fullPath: '/customers/$customerId';
      preLoaderRoute: typeof AppCustomersCustomerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/deals/': {
      id: '/_app/deals/';
      path: '/deals';
      fullPath: '/deals/';
      preLoaderRoute: typeof AppDealsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/deals/$dealId': {
      id: '/_app/deals/$dealId';
      path: '/deals/$dealId';
      fullPath: '/deals/$dealId';
      preLoaderRoute: typeof AppDealsDealIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/deals/leads': {
      id: '/_app/deals/leads';
      path: '/deals/leads';
      fullPath: '/deals/leads';
      preLoaderRoute: typeof AppDealsLeadsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/imports/': {
      id: '/_app/imports/';
      path: '/imports';
      fullPath: '/imports/';
      preLoaderRoute: typeof AppImportsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/imports/$importId': {
      id: '/_app/imports/$importId';
      path: '/imports/$importId';
      fullPath: '/imports/$importId';
      preLoaderRoute: typeof AppImportsImportIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/leads/': {
      id: '/_app/leads/';
      path: '/leads';
      fullPath: '/leads/';
      preLoaderRoute: typeof AppLeadsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/leads/$leadId': {
      id: '/_app/leads/$leadId';
      path: '/leads/$leadId';
      fullPath: '/leads/$leadId';
      preLoaderRoute: typeof AppLeadsLeadIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/proposals/': {
      id: '/_app/proposals/';
      path: '/proposals';
      fullPath: '/proposals/';
      preLoaderRoute: typeof AppProposalsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/proposals/$proposalId': {
      id: '/_app/proposals/$proposalId';
      path: '/proposals/$proposalId';
      fullPath: '/proposals/$proposalId';
      preLoaderRoute: typeof AppProposalsProposalIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/tickets/$ticketId': {
      id: '/_app/tickets/$ticketId';
      path: '/tickets/$ticketId';
      fullPath: '/tickets/$ticketId';
      preLoaderRoute: typeof AppTicketsTicketIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/channels/instagram/callback': {
      id: '/channels/instagram/callback';
      path: '/channels/instagram/callback';
      fullPath: '/channels/instagram/callback';
      preLoaderRoute: typeof ChannelsInstagramCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app/campaigns/audiences/': {
      id: '/_app/campaigns/audiences/';
      path: '/audiences';
      fullPath: '/campaigns/audiences/';
      preLoaderRoute: typeof AppCampaignsAudiencesIndexRouteImport;
      parentRoute: typeof AppCampaignsRouteRoute;
    };
    '/_app/campaigns/broadcasts/': {
      id: '/_app/campaigns/broadcasts/';
      path: '/broadcasts';
      fullPath: '/campaigns/broadcasts/';
      preLoaderRoute: typeof AppCampaignsBroadcastsIndexRouteImport;
      parentRoute: typeof AppCampaignsRouteRoute;
    };
    '/_app/campaigns/broadcasts/$broadcastId': {
      id: '/_app/campaigns/broadcasts/$broadcastId';
      path: '/broadcasts/$broadcastId';
      fullPath: '/campaigns/broadcasts/$broadcastId';
      preLoaderRoute: typeof AppCampaignsBroadcastsBroadcastIdRouteImport;
      parentRoute: typeof AppCampaignsRouteRoute;
    };
    '/_app/campaigns/events/': {
      id: '/_app/campaigns/events/';
      path: '/events';
      fullPath: '/campaigns/events/';
      preLoaderRoute: typeof AppCampaignsEventsIndexRouteImport;
      parentRoute: typeof AppCampaignsRouteRoute;
    };
    '/_app/campaigns/events/$eventId': {
      id: '/_app/campaigns/events/$eventId';
      path: '/events/$eventId';
      fullPath: '/campaigns/events/$eventId';
      preLoaderRoute: typeof AppCampaignsEventsEventIdRouteImport;
      parentRoute: typeof AppCampaignsRouteRoute;
    };
    '/_app/campaigns/journeys/': {
      id: '/_app/campaigns/journeys/';
      path: '/journeys';
      fullPath: '/campaigns/journeys/';
      preLoaderRoute: typeof AppCampaignsJourneysIndexRouteImport;
      parentRoute: typeof AppCampaignsRouteRoute;
    };
    '/_app/campaigns/journeys/$journeyId': {
      id: '/_app/campaigns/journeys/$journeyId';
      path: '/journeys/$journeyId';
      fullPath: '/campaigns/journeys/$journeyId';
      preLoaderRoute: typeof AppCampaignsJourneysJourneyIdRouteImport;
      parentRoute: typeof AppCampaignsRouteRoute;
    };
    '/_app/capture/forms/': {
      id: '/_app/capture/forms/';
      path: '/forms';
      fullPath: '/capture/forms/';
      preLoaderRoute: typeof AppCaptureFormsIndexRouteImport;
      parentRoute: typeof AppCaptureRouteRoute;
    };
    '/_app/capture/forms/$formId': {
      id: '/_app/capture/forms/$formId';
      path: '/forms/$formId';
      fullPath: '/capture/forms/$formId';
      preLoaderRoute: typeof AppCaptureFormsFormIdRouteRouteImport;
      parentRoute: typeof AppCaptureRouteRoute;
    };
    '/_app/capture/referrals/': {
      id: '/_app/capture/referrals/';
      path: '/referrals';
      fullPath: '/capture/referrals/';
      preLoaderRoute: typeof AppCaptureReferralsIndexRouteImport;
      parentRoute: typeof AppCaptureRouteRoute;
    };
    '/_app/capture/forms/$formId/': {
      id: '/_app/capture/forms/$formId/';
      path: '/';
      fullPath: '/capture/forms/$formId/';
      preLoaderRoute: typeof AppCaptureFormsFormIdIndexRouteImport;
      parentRoute: typeof AppCaptureFormsFormIdRouteRoute;
    };
    '/_app/capture/forms/$formId/options': {
      id: '/_app/capture/forms/$formId/options';
      path: '/options';
      fullPath: '/capture/forms/$formId/options';
      preLoaderRoute: typeof AppCaptureFormsFormIdOptionsRouteImport;
      parentRoute: typeof AppCaptureFormsFormIdRouteRoute;
    };
    '/_app/capture/forms/$formId/responses': {
      id: '/_app/capture/forms/$formId/responses';
      path: '/responses';
      fullPath: '/capture/forms/$formId/responses';
      preLoaderRoute: typeof AppCaptureFormsFormIdResponsesRouteImport;
      parentRoute: typeof AppCaptureFormsFormIdRouteRoute;
    };
    '/_app/capture/forms/$formId/share': {
      id: '/_app/capture/forms/$formId/share';
      path: '/share';
      fullPath: '/capture/forms/$formId/share';
      preLoaderRoute: typeof AppCaptureFormsFormIdShareRouteImport;
      parentRoute: typeof AppCaptureFormsFormIdRouteRoute;
    };
  }
}

interface ThemeRouteRouteChildren {
  ThemeKanbanRoute: typeof ThemeKanbanRoute;
  ThemeListRoute: typeof ThemeListRoute;
  ThemeIndexRoute: typeof ThemeIndexRoute;
}

const ThemeRouteRouteChildren: ThemeRouteRouteChildren = {
  ThemeKanbanRoute: ThemeKanbanRoute,
  ThemeListRoute: ThemeListRoute,
  ThemeIndexRoute: ThemeIndexRoute,
};

const ThemeRouteRouteWithChildren = ThemeRouteRoute._addFileChildren(
  ThemeRouteRouteChildren,
);

interface AppAutomationsRouteRouteChildren {
  AppAutomationsAutomationIdRoute: typeof AppAutomationsAutomationIdRoute;
  AppAutomationsNewRoute: typeof AppAutomationsNewRoute;
  AppAutomationsIndexRoute: typeof AppAutomationsIndexRoute;
}

const AppAutomationsRouteRouteChildren: AppAutomationsRouteRouteChildren = {
  AppAutomationsAutomationIdRoute: AppAutomationsAutomationIdRoute,
  AppAutomationsNewRoute: AppAutomationsNewRoute,
  AppAutomationsIndexRoute: AppAutomationsIndexRoute,
};

const AppAutomationsRouteRouteWithChildren =
  AppAutomationsRouteRoute._addFileChildren(AppAutomationsRouteRouteChildren);

interface AppCampaignsRouteRouteChildren {
  AppCampaignsTemplatesRoute: typeof AppCampaignsTemplatesRoute;
  AppCampaignsIndexRoute: typeof AppCampaignsIndexRoute;
  AppCampaignsBroadcastsBroadcastIdRoute: typeof AppCampaignsBroadcastsBroadcastIdRoute;
  AppCampaignsEventsEventIdRoute: typeof AppCampaignsEventsEventIdRoute;
  AppCampaignsJourneysJourneyIdRoute: typeof AppCampaignsJourneysJourneyIdRoute;
  AppCampaignsAudiencesIndexRoute: typeof AppCampaignsAudiencesIndexRoute;
  AppCampaignsBroadcastsIndexRoute: typeof AppCampaignsBroadcastsIndexRoute;
  AppCampaignsEventsIndexRoute: typeof AppCampaignsEventsIndexRoute;
  AppCampaignsJourneysIndexRoute: typeof AppCampaignsJourneysIndexRoute;
}

const AppCampaignsRouteRouteChildren: AppCampaignsRouteRouteChildren = {
  AppCampaignsTemplatesRoute: AppCampaignsTemplatesRoute,
  AppCampaignsIndexRoute: AppCampaignsIndexRoute,
  AppCampaignsBroadcastsBroadcastIdRoute:
    AppCampaignsBroadcastsBroadcastIdRoute,
  AppCampaignsEventsEventIdRoute: AppCampaignsEventsEventIdRoute,
  AppCampaignsJourneysJourneyIdRoute: AppCampaignsJourneysJourneyIdRoute,
  AppCampaignsAudiencesIndexRoute: AppCampaignsAudiencesIndexRoute,
  AppCampaignsBroadcastsIndexRoute: AppCampaignsBroadcastsIndexRoute,
  AppCampaignsEventsIndexRoute: AppCampaignsEventsIndexRoute,
  AppCampaignsJourneysIndexRoute: AppCampaignsJourneysIndexRoute,
};

const AppCampaignsRouteRouteWithChildren =
  AppCampaignsRouteRoute._addFileChildren(AppCampaignsRouteRouteChildren);

interface AppCaptureFormsFormIdRouteRouteChildren {
  AppCaptureFormsFormIdOptionsRoute: typeof AppCaptureFormsFormIdOptionsRoute;
  AppCaptureFormsFormIdResponsesRoute: typeof AppCaptureFormsFormIdResponsesRoute;
  AppCaptureFormsFormIdShareRoute: typeof AppCaptureFormsFormIdShareRoute;
  AppCaptureFormsFormIdIndexRoute: typeof AppCaptureFormsFormIdIndexRoute;
}

const AppCaptureFormsFormIdRouteRouteChildren: AppCaptureFormsFormIdRouteRouteChildren =
  {
    AppCaptureFormsFormIdOptionsRoute: AppCaptureFormsFormIdOptionsRoute,
    AppCaptureFormsFormIdResponsesRoute: AppCaptureFormsFormIdResponsesRoute,
    AppCaptureFormsFormIdShareRoute: AppCaptureFormsFormIdShareRoute,
    AppCaptureFormsFormIdIndexRoute: AppCaptureFormsFormIdIndexRoute,
  };

const AppCaptureFormsFormIdRouteRouteWithChildren =
  AppCaptureFormsFormIdRouteRoute._addFileChildren(
    AppCaptureFormsFormIdRouteRouteChildren,
  );

interface AppCaptureRouteRouteChildren {
  AppCaptureSourcesRoute: typeof AppCaptureSourcesRoute;
  AppCaptureIndexRoute: typeof AppCaptureIndexRoute;
  AppCaptureFormsFormIdRouteRoute: typeof AppCaptureFormsFormIdRouteRouteWithChildren;
  AppCaptureFormsIndexRoute: typeof AppCaptureFormsIndexRoute;
  AppCaptureReferralsIndexRoute: typeof AppCaptureReferralsIndexRoute;
}

const AppCaptureRouteRouteChildren: AppCaptureRouteRouteChildren = {
  AppCaptureSourcesRoute: AppCaptureSourcesRoute,
  AppCaptureIndexRoute: AppCaptureIndexRoute,
  AppCaptureFormsFormIdRouteRoute: AppCaptureFormsFormIdRouteRouteWithChildren,
  AppCaptureFormsIndexRoute: AppCaptureFormsIndexRoute,
  AppCaptureReferralsIndexRoute: AppCaptureReferralsIndexRoute,
};

const AppCaptureRouteRouteWithChildren = AppCaptureRouteRoute._addFileChildren(
  AppCaptureRouteRouteChildren,
);

interface AppRouteChildren {
  AppAutomationsRouteRoute: typeof AppAutomationsRouteRouteWithChildren;
  AppCampaignsRouteRoute: typeof AppCampaignsRouteRouteWithChildren;
  AppCaptureRouteRoute: typeof AppCaptureRouteRouteWithChildren;
  AppConversationsRoute: typeof AppConversationsRoute;
  AppReportsRoute: typeof AppReportsRoute;
  AppSupervisionRoute: typeof AppSupervisionRoute;
  AppTasksRoute: typeof AppTasksRoute;
  AppIndexRoute: typeof AppIndexRoute;
  AppCustomersCustomerIdRoute: typeof AppCustomersCustomerIdRoute;
  AppDealsDealIdRoute: typeof AppDealsDealIdRoute;
  AppDealsLeadsRoute: typeof AppDealsLeadsRoute;
  AppImportsImportIdRoute: typeof AppImportsImportIdRoute;
  AppLeadsLeadIdRoute: typeof AppLeadsLeadIdRoute;
  AppProposalsProposalIdRoute: typeof AppProposalsProposalIdRoute;
  AppTicketsTicketIdRoute: typeof AppTicketsTicketIdRoute;
  AppContactsIndexRoute: typeof AppContactsIndexRoute;
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute;
  AppDealsIndexRoute: typeof AppDealsIndexRoute;
  AppImportsIndexRoute: typeof AppImportsIndexRoute;
  AppLeadsIndexRoute: typeof AppLeadsIndexRoute;
  AppProposalsIndexRoute: typeof AppProposalsIndexRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppAutomationsRouteRoute: AppAutomationsRouteRouteWithChildren,
  AppCampaignsRouteRoute: AppCampaignsRouteRouteWithChildren,
  AppCaptureRouteRoute: AppCaptureRouteRouteWithChildren,
  AppConversationsRoute: AppConversationsRoute,
  AppReportsRoute: AppReportsRoute,
  AppSupervisionRoute: AppSupervisionRoute,
  AppTasksRoute: AppTasksRoute,
  AppIndexRoute: AppIndexRoute,
  AppCustomersCustomerIdRoute: AppCustomersCustomerIdRoute,
  AppDealsDealIdRoute: AppDealsDealIdRoute,
  AppDealsLeadsRoute: AppDealsLeadsRoute,
  AppImportsImportIdRoute: AppImportsImportIdRoute,
  AppLeadsLeadIdRoute: AppLeadsLeadIdRoute,
  AppProposalsProposalIdRoute: AppProposalsProposalIdRoute,
  AppTicketsTicketIdRoute: AppTicketsTicketIdRoute,
  AppContactsIndexRoute: AppContactsIndexRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppDealsIndexRoute: AppDealsIndexRoute,
  AppImportsIndexRoute: AppImportsIndexRoute,
  AppLeadsIndexRoute: AppLeadsIndexRoute,
  AppProposalsIndexRoute: AppProposalsIndexRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute;
  AuthLoginRoute: typeof AuthLoginRoute;
  AuthRegisterRoute: typeof AuthRegisterRoute;
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute;
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
};

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren);

interface HelpRouteChildren {
  HelpSplatRoute: typeof HelpSplatRoute;
  HelpIndexRoute: typeof HelpIndexRoute;
}

const HelpRouteChildren: HelpRouteChildren = {
  HelpSplatRoute: HelpSplatRoute,
  HelpIndexRoute: HelpIndexRoute,
};

const HelpRouteWithChildren = HelpRoute._addFileChildren(HelpRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  ThemeRouteRoute: ThemeRouteRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  HelpRoute: HelpRouteWithChildren,
  InscricaoTokenRoute: InscricaoTokenRoute,
  ChannelsInstagramCallbackRoute: ChannelsInstagramCallbackRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
